<template>
  <div id="goods-list" class="app-container">
    <div class="tools-bar">
      <div class="form-item">
        <span class="form-label">快速筛选商品</span>
        <el-select v-model="params.isOnsale" placeholder="请选择" clearable style="width: 140px;">
          <el-option label="上架" :value="1" />
          <el-option label="下架" :value="0" />
        </el-select>
      </div>
      <div>
        <el-button type="success" plain :loading="tempInterval != null" @click="syncTemp">同步运费模板</el-button>
        <el-button type="primary" :loading="interval != null" @click="openSync">同步商品</el-button>
        <el-button type="warning" :loading="updateInterval != null" @click="updateGoods">更新商品数据</el-button>
      </div>
    </div>
    <list row-key="id" ref="list" unit="商品" :page="page" :query-params="params" :show-query="showQuery"
      :show-checkbox="true" :page-size="50" :get-data-func="getDataFunc">
      <template slot="query">
        <el-form-item label="商品类目" label-width="105px">
          <el-cascader ref="catRef" v-model="params.catIds" :props="cascaderProps" clearable style="width: 100%;" />
        </el-form-item>
        <el-form-item label="库存范围" label-width="105px">
          <div style="display: flex;align-items: center;">
            <el-input-number v-model="params.stockStart" :controls="false" placeholder="最低库存" style="width: 100px;" />
            <span style="margin: 0 7.5px;">-</span>
            <el-input-number v-model="params.stockEnd" :controls="false" placeholder="最高库存" style="width: 100px;" />
          </div>
        </el-form-item>
        <el-form-item label="运费模板" label-width="105px">
          <el-select v-model="params.costTemplateId" placeholder="请选择模板" clearable style="width: 100%;">
            <el-option v-for="(i, k) in freightList" :key="k" :label="i.templateName" :value="i.templateId" />
          </el-select>
        </el-form-item>
        <el-form-item label="商品搜索" label-width="105px">
          <div class="query-input" data-key="keywords" @click="onKeywordsClick">
            <el-input v-model="params.keywords" placeholder="请输入商品名称/编码（多行批量）" readonly />
            <div class="input-textarea" v-show="showTextarea.keywords" @click.stop>
              <el-input type="textarea" v-model="params.keywords" :rows="6" resize="none" spellcheck="false"
                placeholder="一行一个" />
            </div>
          </div>
        </el-form-item>
      </template>
      <template slot="toolbar-right">
        <div style="display: flex;align-items: center;width: 100%;justify-content: flex-end;">
          <div>
            <el-button type="primary" @click="openBatchEdit('title')">批量修改标题</el-button>
            <el-button type="primary" @click="openBatchEdit('stock')">批量修改库存</el-button>
            <el-button type="primary" @click="openBatchEdit('template')">批量修改运费模板</el-button>
            <el-button type="danger" @click="openBatchEdit('delete')">批量删除</el-button>
          </div>
        </div>
      </template>
      <template slot="table">
        <el-table-column label="商品图片" width="100px" align="center">
          <template slot-scope="{row}">
            <div class="goods-img">
              <el-image v-if="row.thumbUrl" :src="row.thumbUrl" fit="contain" />
            </div>
          </template>
        </el-table-column>
        <el-table-column label="商品信息" min-width="200px">
          <template slot-scope="{row}">
            <div>{{ row.goodsName }}</div>
            <div style="font-size: 12px;color: #A8ABB2;">外部编码：{{ row.outerGoodsId || '--' }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="goodsQuantity" label="库存" width="80px" />
        <el-table-column prop="goodsId" label="商品编码" width="120px" />
        <el-table-column label="售卖状态" width="90px">
          <template slot-scope="{row}">
            <el-tag v-if="row.isOnsale === 1" type="success">上架</el-tag>
            <el-tag v-else type="danger">下架</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="状态" width="80px">
          <template slot-scope="{row}">
            <el-tag v-if="row.status === 0" type="success">正常</el-tag>
            <el-tag v-else type="warning">审核中</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="createdAt" label="创建时间" width="160px" />
        <!-- slot[column] -->
        <slot name="column"></slot>
        <!--/ slot[column]-->
      </template>
      <template slot="column">
        <el-table-column label="操作" align="center" width="110" fixed="right">
          <template slot-scope="{row}">
            <div style="line-height: 28px;">
              <el-dropdown trigger="click" @command="handleCommand">
                <el-button type="primary">
                  操作<i class="el-icon-arrow-down el-icon--right" />
                </el-button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item :command="{ action: 'setOnline', data: row }">上架</el-dropdown-item>
                  <el-dropdown-item :command="{ action: 'setOutline', data: row }">下架</el-dropdown-item>
                  <el-dropdown-item :command="{ action: 'editTitle', data: row }">修改标题</el-dropdown-item>
                  <el-dropdown-item :command="{ action: 'editStock', data: row }">修改库存</el-dropdown-item>
                  <el-dropdown-item :command="{ action: 'editTemplate', data: row }">修改模板</el-dropdown-item>
                  <el-dropdown-item :command="{ action: 'editGoodsNumber', data: row }">修改商品编码</el-dropdown-item>
                  <el-dropdown-item :command="{ action: 'editSkuNumber', data: row }">修改SKU编码</el-dropdown-item>
                  <el-dropdown-item :command="{ action: 'deleteGoods', data: row }">删除</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </template>
        </el-table-column>
      </template>
    </list>
    <sync-dialog ref="syncDialog" @close-saved="onSync" />
    <edit-title-dialog ref="editTitleDialog" @close-saved="reload" />
    <edit-stock-dialog ref="editStockDialog" @close-saved="reload" />
    <edit-template-dialog ref="editTemplateDialog" @close-saved="reload" />
    <edit-out-goods-id-dialog ref="editOutGoodsIdDialog" @close-saved="reload" />
    <edit-out-sku-sn-dialog ref="editOutSkuSnDialog" @close-saved="reload" />
    <batch-edit-title-dialog ref="batchEditTitleDialog" @close-saved="reload" />
    <batch-edit-stock-dialog ref="batchEditStockDialog" @close-saved="reload" />
  </div>
</template>
<script>
import listMixin from "@/mixins/list";
import list from "@/components/common/list";
import goodsApi from '@/api/pdd/goods';
import tempApi from '@/api/pdd/temp';
import SyncDialog from './components/SyncDialog';
import EditTitleDialog from './components/EditTitleDialog';
import EditStockDialog from './components/EditStockDialog';
import EditTemplateDialog from './components/EditTemplateDialog';
import EditOutGoodsIdDialog from './components/EditOutGoodsIdDialog';
import EditOutSkuSnDialog from './components/EditOutSkuSnDialog';
import BatchEditTitleDialog from './components/BatchEditTitleDialog';
import BatchEditStockDialog from './components/BatchEditStockDialog';

export default {
  name: "goods",
  mixins: [listMixin],
  components: {
    list,
    SyncDialog,
    EditTitleDialog,
    EditStockDialog,
    EditTemplateDialog,
    EditOutGoodsIdDialog,
    EditOutSkuSnDialog,
    BatchEditTitleDialog,
    BatchEditStockDialog,
  },
  data() {
    return {
      params: {
        isOnsale: null,
        catId: null,
        catIds: [],
        keywords: '',
        keywordValues: [],
        costTemplateId: null,
        stockStart: undefined,
        stockEnd: undefined,
      },
      showTextarea: { keywords: false },
      freightList: [],
      interval: null,
      tempInterval: null,
      updateInterval: null,
    }
  },
  computed: {
    cascaderProps() {
      var self = this;
      return {
        lazy: true,
        checkStrictly: true,
        lazyLoad: function (node, resolve) {
          var id = Number(node.value || 0);
          self.getCats(id).then(function (nodes) {
            resolve(nodes);
          });
        },
      };
    },
  },
  created() {
    this.getTempList();
    this.taskStatus();
    this.tempTaskStatus();
    this.updateTaskStatus();
  },
  watch: {
    'params.keywords': function (value) {
      if (value) {
        var values = value.split('\n');
        values = values.map(function (x) { return x.trim(); });
        values = values.filter(function (x) { return x !== ''; });
        this.params.keywordValues = values;
      } else {
        this.params.keywordValues = [];
      }
    },
    'params.catIds': function () {
      if (this.$refs.catRef) {
        var nodes = this.$refs.catRef.getCheckedNodes(false);
        if (nodes.length > 0) this.params.catId = nodes[0].value;
        else this.params.catId = null;
      }
    },
  },
  methods: {
    // --- 数据加载 ---
    getDataFunc(params) {
      params = this.$commonJs.obj.removeNullKey({
        ...params,
        keywordValues: this.params.keywordValues,
        catId: this.params.catId,
        stockStart: this.params.stockStart,
        stockEnd: this.params.stockEnd,
        costTemplateId: this.params.costTemplateId,
        isOnsale: this.params.isOnsale,
      });
      console.log("params", { ...params })
      return new Promise(function (resolve) {
        goodsApi.getGoods(params).then(function (res) {
          // 后端返回 { count, data }，list组件需要 { data: [...], count: N }
          resolve({ data: res.data, count: res.count });
        }).catch(function () {
          resolve({ data: [], count: 0 });
        });
      });
    },
    reload() {
      if (this.$refs.list) this.$refs.list.getData();
    },

    // --- 商品类目级联 ---
    getCats(id) {
      return new Promise(function (resolve) {
        goodsApi.cats(id).then(function (res) {
          var data = [];
          if (res.code === 0) {
            data = (res.data || []).map(function (x) {
              return { value: x.catId, label: x.catName, leaf: x.leaf };
            });
          }
          resolve(data);
        });
      });
    },

    // --- 关键字输入 ---
    onKeywordsClick(e) {
      this.showTextarea.keywords = true;
      this.$nextTick(function () {
        var ta = e.currentTarget.querySelector('textarea');
        if (ta) ta.focus();
      });
    },
    handleDocumentClick(e) {
      var now_key = '';
      var path = e.composedPath ? e.composedPath() : [];
      var input = path.find(function (el) {
        return el.className && el.className.indexOf && el.className.indexOf('query-input') !== -1;
      });
      if (input) {
        now_key = input.dataset ? input.dataset.key : '';
      }
      var keys = Object.keys(this.showTextarea);
      keys = keys.filter(function (x) { return x !== now_key; });
      var self = this;
      keys.forEach(function (key) {
        self.$set(self.showTextarea, key, false);
      });
    },

    // --- 运费模板 ---
    getTempList() {
      var self = this;
      return new Promise(function (resolve) {
        tempApi.list().then(function (res) {
          if (res.code === 0) self.freightList = res.data;
          resolve(res);
        });
      });
    },

    // --- 同步任务状态 ---
    taskStatus() {
      var self = this;
      goodsApi.syncStatus().then(function (res) {
        if (res.code === 1) {
          self.interval = setInterval(function () {
            goodsApi.syncStatus().then(function (s) {
              if (s.code !== 1) {
                if (self.interval) {
                  clearInterval(self.interval);
                  self.interval = null;
                }
                self.handleResponse(s, 0);
              }
            }).catch(function () {
              clearInterval(self.interval);
              self.interval = null;
            });
          }, 3000);
        } else {
          self.handleResponse(res, 0);
        }
      });
    },
    tempTaskStatus() {
      var self = this;
      tempApi.syncStatus().then(function (res) {
        if (res.code === 1) {
          self.tempInterval = setInterval(function () {
            tempApi.syncStatus().then(function (s) {
              if (s.code !== 1) {
                if (self.tempInterval) {
                  clearInterval(self.tempInterval);
                  self.tempInterval = null;
                }
                self.handleResponse(s, 1);
              }
            }).catch(function () {
              clearInterval(self.tempInterval);
              self.tempInterval = null;
            });
          }, 3000);
        } else {
          self.handleResponse(res, 1);
        }
      });
    },
    updateTaskStatus() {
      var self = this;
      goodsApi.updateStatus().then(function (res) {
        if (res.code === 1) {
          self.updateInterval = setInterval(function () {
            goodsApi.updateStatus().then(function (s) {
              if (s.code !== 1) {
                if (self.updateInterval) {
                  clearInterval(self.updateInterval);
                  self.updateInterval = null;
                }
                self.handleResponse(s, 0);
              }
            }).catch(function () {
              clearInterval(self.updateInterval);
              self.updateInterval = null;
            });
          }, 3000);
        } else {
          self.handleResponse(res, 0);
        }
      });
    },
    handleResponse(res, type) {
      if (res.code === 2) {
        this.$alert('同步成功', '提示', { type: 'success', confirmButtonText: '确 认' });
        if (type === 0) this.reload();
        if (type === 1) this.getTempList();
      }
      if (res.code === 3) {
        this.$alert(res.msg || '同步失败', '提示', { type: 'error', confirmButtonText: '确 认' });
      }
    },

    // --- 同步操作 ---
    openSync() {
      this.$refs.syncDialog.open();
    },
    onSync(data) {
      var self = this;
      var loading = this.$loading({ lock: true, text: '正在开始同步...', background: 'rgba(0, 0, 0, 0.3)' });
      goodsApi.sync(data).then(function () {
        self.taskStatus();
        loading.close();
      }).catch(function () {
        loading.close();
      });
    },
    syncTemp() {
      var self = this;
      tempApi.sync().then(function () {
        self.tempTaskStatus();
      });
    },
    updateGoods() {
      var self = this;
      goodsApi.update().then(function () {
        self.updateTaskStatus();
      });
    },

    // --- 批量操作 ---
    getCheckedRows() {
      var list = this.$refs.list;
      if (!list) return [];
      return list.getCheckedRows();
    },
    openBatchEdit(type) {
      var rows = this.getCheckedRows();
      if (rows.length === 0) {
        this.$message.warning('请先选择数据');
        return;
      }
      switch (type) {
        case 'online':
          this.batchOnline(rows);
          break;
        case 'outline':
          this.batchOutline(rows);
          break;
        case 'title':
          this.$refs.batchEditTitleDialog.openEdit(rows);
          break;
        case 'stock':
          this.$refs.batchEditStockDialog.openEdit(rows);
          break;
        case 'template':
          this.$refs.editTemplateDialog.openEdit(rows, true);
          break;
        case 'delete':
          this.batchDelete(rows);
          break;
      }
    },

    // --- 上下架 ---
    batchOnline(rows) {
      var self = this;
      this.$confirm('是否对商品进行上架操作？', '提示', { type: 'warning' }).then(function () {
        var data = { dataList: rows.map(function (x) { return { goodsId: x.goodsId, isOnsale: 1 }; }) };
        var loading = self.$loading({ lock: true, text: '正在上架...', background: 'rgba(0, 0, 0, 0.3)' });
        goodsApi.salestatus(data).then(function (res) {
          loading.close();
          if (res.data && res.data.length !== 0) {
            var html = '';
            res.data.forEach(function (x) { html += '<div>' + x.title + '：' + x.errorMsg + '</div>' });
            self.$alert(html, '提示', { dangerouslyUseHTMLString: true, type: 'error' });
          } else {
            self.$message.success('上架成功');
            self.reload();
          }
        }).catch(function () { loading.close(); });
      }).catch(function () { });
    },
    batchOutline(rows) {
      var self = this;
      this.$confirm('是否对商品进行下架操作？', '提示', { type: 'warning' }).then(function () {
        var data = { dataList: rows.map(function (x) { return { goodsId: x.goodsId, isOnsale: 0 }; }) };
        var loading = self.$loading({ lock: true, text: '正在下架...', background: 'rgba(0, 0, 0, 0.3)' });
        goodsApi.salestatus(data).then(function (res) {
          loading.close();
          if (res.data && res.data.length !== 0) {
            var html = '';
            res.data.forEach(function (x) { html += '<div>' + x.title + '：' + x.errorMsg + '</div>' });
            self.$alert(html, '提示', { dangerouslyUseHTMLString: true, type: 'error' });
          } else {
            self.$message.success('下架成功');
            self.reload();
          }
        }).catch(function () { loading.close(); });
      }).catch(function () { });
    },

    // --- 批量删除 ---
    batchDelete(rows) {
      var ids = rows.map(function (x) { return x.goodsId; });
      if (ids.length > 50) {
        this.$message.warning('一次删除的行数不能大于50条');
        return;
      }
      var self = this;
      this.$confirm('是否对商品进行删除操作？', '提示', { type: 'warning' }).then(function () {
        var loading = self.$loading({ lock: true, text: '正在删除...', background: 'rgba(0, 0, 0, 0.3)' });
        goodsApi.delete({ ids: ids }).then(function (res) {
          loading.close();
          if (res.code === 0) {
            self.$message.success('删除成功');
            self.reload();
          } else {
            if (res.msg) {
              try {
                var msg = JSON.parse(res.msg);
                var html = '';
                Object.keys(msg).forEach(function (key) { html += '<div>' + key + '：' + msg[key] + '</div>' });
                self.$alert(html, '提示', { dangerouslyUseHTMLString: true, type: 'error' });
              } catch (e) {
                self.$alert(res.msg, '提示', { type: 'error' });
              }
            } else {
              self.$alert('删除失败', '提示', { type: 'error' });
            }
          }
        }).catch(function () { loading.close(); });
      }).catch(function () { });
    },

    // --- 行操作下拉菜单 ---
    handleCommand(command) {
      var actionMap = {
        setOnline: function (data) { this.batchOnline([data]); },
        setOutline: function (data) { this.batchOutline([data]); },
        editTitle: function (data) { this.$refs.editTitleDialog.openEdit(data); },
        editStock: function (data) { this.$refs.editStockDialog.openEdit(data); },
        editTemplate: function (data) { this.$refs.editTemplateDialog.openEdit([data], false); },
        editGoodsNumber: function (data) { this.$refs.editOutGoodsIdDialog.openEdit(data); },
        editSkuNumber: function (data) { this.$refs.editOutSkuSnDialog.openEdit(data); },
        deleteGoods: function (data) { this.batchDelete([data]); },
      };
      var fn = actionMap[command.action];
      if (fn) fn.call(this, command.data);
    },
  },
  mounted() {
    document.addEventListener('click', this.handleDocumentClick);
    this.reload();
  },
  beforeDestroy() {
    document.removeEventListener('click', this.handleDocumentClick);
    if (this.interval) clearInterval(this.interval);
    if (this.tempInterval) clearInterval(this.tempInterval);
    if (this.updateInterval) clearInterval(this.updateInterval);
  },
}
</script>
<style lang="scss">
#goods-list {
  .goods-img {
    display: flex;
    justify-content: center;
    width: 100%;
    height: 80px;

    .el-image {
      width: 60px;
      height: 60px;
    }
  }
}

.tools-bar {
  height: 40px;
  line-height: 40px;
  display: flex;
  justify-content: space-between;
  border: 1px solid #dcdfe6;
  border-bottom: none;
  padding: 0 10px;
  background: #fff;

  .form-item {
    display: flex;
    align-items: center;

    .form-label {
      width: 110px;
      color: #909399;
      font-size: 14px;
    }
  }
}

.query-input {
  position: relative;

  .input-textarea {
    width: 220px;
    background-color: #ffffff;
    padding: 5px;
    border-radius: 5px;
    box-shadow: 0 0 7px 2px #c7c7c7;
    position: absolute;
    top: 0;
    z-index: 2001;

    .el-textarea__inner {
      padding: 5px;
    }
  }
}
</style>
